import React, { useState, useEffect } from "react";
import CommonCard from "../common/commonCard";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import { Container, Row, Col, Button } from "react-bootstrap";
import FormCard from "../common/formCard";
import { useLocation } from "react-router-dom";
import Footer from "../common/footer";
import { useNavigate, useParams } from "react-router-dom";
import { GetUserservice, PatchUserService } from "../../Services/userService";
import MessagePopUp from "../common/messagePopUp";
import Spinner from 'react-bootstrap/Spinner';
import { GetRolsService } from "../../Services/selectFieldsService";

import { useTranslation } from 'react-i18next';

const EditUser = () => {
  const [t] = useTranslation("users")
  const [apiData, setApiData] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [showPopupError, setShowPopupError] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [showPopupContinue, setShowPopupContinue] = useState(false);
  const [showModalContinue, setShowModalContinue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const location = useLocation();
  const itemData = location.state?.data || {};
  const [isFormValid, setIsFormValid] = useState(false);
  const [formDataChanged, setFormDataChanged] = useState(false);
  const [changedFields, setChangedFields] = useState({});
  const [changeData, setChangeData] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    name: false,
    nameMessage: null,
  });
  const [rols, setRols] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { id } = useParams();

  const navigate = useNavigate();

  let initialFormData = {}
  if (loaded) {
    initialFormData = {
      name: userData.name,
      surname: userData.surname,
      mail: userData.mail,
      nif: userData.nif,
      rol: userData.rol,
    }
  }

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (loaded) {
      setFormData({
        name: userData.name,
        surname: userData.surname,
        mail: userData.mail,
        nif: userData.nif,
        rol: userData.rol,
      });
    }
  }, [loaded, userData]);

  // Verifica si formData ha cambiado con respecto a initialFormData
  useEffect(() => {
    if (loaded) {
      const dataChanged =
        JSON.stringify(initialFormData) !== JSON.stringify(formData);
      setFormDataChanged(dataChanged);
    }

  }, [formData]);

  const isValidCIF = (cif) => {
    const regex = /^[A-Za-z][0-9]{7}[A-Za-z0-9]$/;
    return regex.test(cif);
  };

  const isValidNIF = (nif) => {
    const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    const nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i;
    const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    let number, letter;

    if (nifRegex.test(nif)) {
      number = parseInt(nif.slice(0, 8), 10);
      letter = nif.slice(8).toUpperCase();
    } else if (nieRegex.test(nif)) {
      const initialLetterMappings = { X: "0", Y: "1", Z: "2" };
      const initialLetter = nif[0].toUpperCase();
      number = parseInt(
        initialLetterMappings[initialLetter] + nif.slice(1, 8),
        10
      );
      letter = nif.slice(8).toUpperCase();
    } else {
      return false; // No es ni NIF ni NIE válido
    }

    return letters[number % 23] === letter;
  };

  const isValidNIFCIF = (string) => {
    if (isValidCIF(string) || isValidNIF(string)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (loaded) {
      const allFieldsValid = Object.values(fieldErrors).every((error) => !error);
      setIsFormValid(allFieldsValid);
    }
  }, [fieldErrors]);

  useEffect(() => {
    const getRols = async () => {
      const rolsNames = await GetRolsService();
      setRols(rolsNames);

      const user = await GetUserservice(id);
      setUserData(user);
      setLoaded(true);
    }
    getRols();
  }, [reloadData])

  const handleCancelClick = async () => {
    navigate("/users");
  };

  //validar campos
  const validateField = (field, value) => {
    let isError = false;
    let errorMessage = null;

    switch (field) {
      case "name":
        const validName = /^[a-zA-ZÀ-ÿ\s\-']+$/u;
        isError = value === "" || !validName.test(value);
        errorMessage = isError ? `${t("createUser.nameError")}` : null;
        break;
      case "surname":
        const validSurname = /^[a-zA-ZÀ-ÿ\s\-']+$/u;
        isError = value === "" || !validSurname.test(value);
        errorMessage = isError ? `${t("createUser.surnameError")}` : null;
        break;
      case "telephone":
        const validTelephone = /^[0-9]{9}$/;
        isError = value.length > 0 ? !validTelephone.test(value) : false;
        errorMessage = isError ? `${t("createUser.phoneError")}` : null;
        break;
      case "mail":
        const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        isError = !validEmail.test(value);
        errorMessage = isError ? `${t("createUser.mailError")}` : null;
        break;
      case "nif":
        isError = !value ? false : !isValidNIFCIF(value);
        errorMessage = isError ? `${t("createUser.nifError")}` : null;
        break;
      case "rol":
        isError = value === "";
        errorMessage = isError ? `${t("createUser.rolError")}` : null;
        break;

      default:
        break;
    }

    setFieldErrors((prevFieldErrors) => {
      const newErrors = { ...prevFieldErrors, [field]: isError };
      newErrors[`${field}Message`] = errorMessage;
      return newErrors;
    });
    return !isError
  };


  const validateAllFields = () => {
    const { name, surname, mail, nif, rol } = formData;


    const isNameValid = validateField("name", name);

    const isSurnameValid = validateField("surname", surname);

    const isMailValid = validateField("mail", mail);

    const isNifValid = !nif ? true : validateField("nif", nif);

    const isRolValid = validateField("rol", rol);

    return isNameValid && isSurnameValid && isMailValid && isNifValid && isRolValid;
  }

  // const handleFieldChange = (field, value) => {
  //   setFormData((prevFormData) => {
  //     const updatedFormData = { ...prevFormData, [field]: value };
  //     validateField(field, value); // Validar el campo cuando se actualiza
  //     return updatedFormData;
  //   });
  // };

  const handleFieldChange = (field, value) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [field]: value };

      // Si el campo ha cambiado respecto al valor inicial, lo añadimos a changedFields
      if (value !== initialFormData[field]) {
        setChangedFields(prev => ({ ...prev, [field]: value }));
      } else {
        // Si el campo vuelve a su valor inicial, lo removemos de changedFields
        setChangedFields(prev => {
          const newChangedFields = { ...prev };
          delete newChangedFields[field];
          return newChangedFields;
        });
      }

      validateField(field, value); // Validar el campo cuando se actualiza
      return updatedFormData;
    });
  };

  const handleSaveClick = async () => {
    setLoading(true)
    if (validateAllFields()) {
      const data = await PatchUserService(changedFields, id);
      setApiData(data);
      if (typeof data !== 'object') {
        setShowPopupError(true);
      } else {
        setShowPopupContinue(true);
      }
    }
    setLoading(false)

  };

  const handleButtonMessagePopUpErrorClick = () => {
    setShowPopupError(false);
    setShowModalError(true);
  };

  const handleButtonMessagePopUpContinueClick = () => {
    setShowPopupContinue(false);
    setShowModalContinue(true);
    setIsFormValid(false);
    setFormDataChanged(false);
    setReloadData(prev => !prev);
    navigate(`/edit-user/${id}`);
  };

  return (
    <div>
      <MessagePopUp
        show={showPopupError}
        handleClose={() => setShowPopupError(false)}
        title={apiData === 'Error NIF' ? `${t("createUser.messageErrorNifTitle")}` : apiData === 'Error MAIL' ? `${t("createUser.messageErrorMailTitle")}` : `${t("createUser.messageErrorAdminTitle")}`}
        textBody={
          apiData === 'Error NIF' ? `${t("createUser.messageErrorNifText")}`
            : apiData === 'Error MAIL' ? `${t("createUser.messageErrorMailText")}` : `${t("createUser.messageErrorAdminText")}`

        }

        buttonText={t("createUser.messageErrorButton")}
        onClickButton={handleButtonMessagePopUpErrorClick}
      />
      <MessagePopUp
        show={showPopupContinue}
        handleClose={() => setShowPopupContinue(false)}
        title={t("createUser.messageSucessEditTitle")}
        textBody={t("createUser.messageSucessEditText")}
        buttonText={t("createUser.messageSucessButton")}
        onClickButton={handleButtonMessagePopUpContinueClick}
      />
      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={() => { setReloadData(!reloadData); setLoaded(false) }}
      />
      <Container fluid>
        <Row>
          <Col
            className='d-flex'
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "2%" : "4%"}`,
            }}
          >
            <Sidebar
              expanded={expanded}
              setExpanded={setExpanded}
              selected={"Usuarios"}
            />
          </Col>
          <Col
            className='custom-content-wrapper'
            style={{
              marginLeft: `0.5%`,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "86%" : "93%"}`,
            }}
          >
            <Row>
              <Col md={12}>
                <CommonCard title={t("editUserCard.title")} icon={"FaUser"}>
                  <Row>
                    <Col md={6}>
                      <FormCard
                        title={t("userForm.name")}
                        text={userData.name}
                        type={"text"}
                        error={fieldErrors.name}
                        errorMessage={fieldErrors.nameMessage}
                        readOnly={false}
                        onChange={(e) =>
                          handleFieldChange("name", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormCard
                        title={t("userForm.surname")}
                        text={userData.surname}
                        type={"text"}
                        error={fieldErrors.surname}
                        errorMessage={fieldErrors.surnameMessage}
                        readOnly={false}
                        onChange={(e) =>
                          handleFieldChange("surname", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormCard
                        title={t("userForm.nif")}
                        text={userData.nif === '-----------' ? '' : userData.nif}
                        type={"text"}
                        error={fieldErrors.nif}
                        errorMessage={fieldErrors.nifMessage}
                        readOnly={false}
                        onChange={(e) =>
                          handleFieldChange("nif", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormCard
                        title={t("userForm.mail")}
                        text={userData.mail}
                        type={"text"}
                        error={fieldErrors.mail}
                        errorMessage={fieldErrors.mailMessage}
                        readOnly={false}
                        onChange={(e) =>
                          handleFieldChange("mail", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormCard
                        title={t("userForm.rol")}
                        text={userData.rol}
                        type={"text"}
                        readOnly={true}
                        key={changeData}
                      />
                    </Col>
                    <Col md={6}>
                      {loaded && (
                        <FormCard
                          title={t("userForm.admin")}
                          type={"select"}
                          error={fieldErrors.rol}
                          errorMessage={fieldErrors.rolMessage}
                          onChange={(e) =>
                            handleFieldChange("rol", e.value)
                          }
                          selectedValue={
                            loaded && userData.rol &&
                              userData.rol.includes(rols[0])
                              ? { label: `${t("userForm.adminOptionYes")}`, value: "si" }
                              : { label: `${t("userForm.adminOptionNo")}`, value: "no" }
                          }
                          options={[
                            { label: `${t("userForm.adminOptionYes")}`, value: "si" },
                            { label: `${t("userForm.adminOptionNo")}`, value: "no" },
                          ]}
                        />
                      )}
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-around mt-4">
                    <Button
                      variant="secondary"
                      className="custom-button-secondary custom-shadow"
                      onClick={handleCancelClick}
                      disabled={loading}

                    >
                      {t("userForm.cancelButton")}
                    </Button>
                    <Button
                      variant="success"
                      className="custom-button-primary custom-shadow"
                      onClick={handleSaveClick}
                      disabled={!isFormValid || !formDataChanged || loading}
                    >
                      {loading ?
                        <>
                          <Spinner animation="border" className="spinner" />
                          <span className="common-card-card-text">{t("userForm.savingButton")}</span>

                        </>
                        :
                        <>
                          {t("userForm.saveButton")}
                        </>
                      }
                    </Button>
                  </div>
                </CommonCard>
              </Col>
            </Row>
            <Footer />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EditUser;
